// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-spacing[data-v-76a0b81b] {\n  margin-top: 72px;\n}", ""]);
// Exports
module.exports = exports;
